module.exports = __webpack_public_path__ + "static/media/Rainbow_Cheerful.5a8d4559.gif";